import log from 'salvo-lite/log'
import AjaxAPI from '../helpers/AjaxAPI'

class Checkout {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        const hostname = window.location.hostname
        if (hostname.includes('trade.grenade.com') || hostname.includes('grenade-uk.myshopify.com')) return
        document.addEventListener('page:change', e => {
            this._elem.querySelector('#continue_button').setAttribute('disabled', '')
            setTimeout(() => {
                this._theme.registerComponents(this._elem.parentNode)
            }, 1500)
        })
        this._elem.querySelector('#continue_button').setAttribute('disabled', '')
        this._checkItems()
    }
    async _checkItems () {
        const cartResponse = await AjaxAPI.getCart()
        const cart = cartResponse.data
        const threshold = cart.attributes.freeGiftThreshold
        const cartTotal = this._elem.querySelector('[data-checkout-payment-due-target]').getAttribute('data-checkout-payment-due-target')
        if (threshold > cartTotal) {
            if (cart.items.find(item => item.properties && item.properties['threshold-free-product'])) {
                const freeGiftItem = cart.items.find(item => item.properties['threshold-free-product'])
                const id = freeGiftItem.id
                await AjaxAPI.removeItem(id)
                location.reload()
            } else {
                this._elem.querySelector('#continue_button').removeAttribute('disabled')
            }
        } else {
            this._elem.querySelector('#continue_button').removeAttribute('disabled')
        }
    }
}

export default Checkout



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Checkout.js